export default __webpack_public_path__ + "static/media/Evento_1.23d1cdc1.jpg";